var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcContractServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 204,
    viewBox: "0 0 191 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0104 157.248L119.445 178.332L58.3447 201.998L17.0374 178.332L82.0104 157.248Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5546 64.8721C48.8133 64.8721 36.879 74.3289 33.7382 87.7065L20.479 144.181C18.1215 154.222 25.741 163.838 36.0554 163.838H98.4429L105.794 181.479L155.61 163.776C165.394 162.924 172.25 153.376 169.634 143.673L153.178 82.6255C150.354 72.1503 140.854 64.8721 130.005 64.8721H62.5546Z",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1787 34.1252C63.7199 24.4479 71.2133 15.7402 80.9999 15.7402H109.948C119.728 15.7402 127.22 24.4366 125.772 34.1087L121.194 64.6916C120.315 70.5675 115.268 74.9152 109.327 74.9152H81.6542C75.7176 74.9152 70.6732 70.5743 69.7883 64.704L65.1787 34.1252Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0104 152.084L100.728 162.626L108.375 176.316L58.3447 196.834L17.0374 173.168L82.0104 152.084Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.195 179.308L100.666 162.962L73.9786 165.504C72.8484 165.612 72.2211 166.866 72.8126 167.835C73.8224 169.489 75.6442 170.472 77.5814 170.408L89.1567 170.026L88.1882 171.36C87.3305 172.541 86.1924 173.49 84.8764 174.122L68.7427 181.869C66.8028 182.801 66.3169 185.343 67.7765 186.924L69.9908 189.323C73.3162 192.926 78.1099 194.805 82.9977 194.422L88.5405 193.988C92.3761 193.687 96.0329 192.241 99.0369 189.837L112.195 179.308Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3717 62.8818C86.4708 62.7723 87.4505 63.5746 87.56 64.6738L87.9945 69.0371C88.1039 70.1363 87.3016 71.116 86.2025 71.2254C85.1034 71.3349 84.1236 70.5326 84.0142 69.4335L83.5797 65.0701C83.4702 63.971 84.2725 62.9912 85.3717 62.8818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.996 62.8818C104.897 62.7723 103.917 63.5746 103.808 64.6738L103.373 69.0371C103.264 70.1363 104.066 71.116 105.165 71.2254C106.264 71.3349 107.244 70.5326 107.354 69.4335L107.788 65.0701C107.897 63.971 107.095 62.9912 105.996 62.8818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8081 78.0429C54.5035 70.4537 34.6594 67.1191 25.9004 66.4004C35.5496 76.7493 48.5876 107.796 53.9004 122.026L87.5004 127.2L63.8081 78.0429Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 74.3033C31.3265 80.1718 34.7642 101.057 40.3505 111.413L46.7962 127.379L85.9002 130.4L61.4065 79.9132C46.7962 73.872 23.8781 72.5773 10.7002 74.3033Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1424 121.046L58.9318 124.695C56.5159 128.684 52.1777 131.289 47.6155 130.323C45.4807 129.872 43.1882 129.159 41.1798 128.037C37.6424 126.061 35.4799 121.092 34.8164 119.504L28.3306 102.133C27.5788 100.12 28.6928 98.01 30.7838 98.5076C30.9268 98.5416 31.0726 98.5797 31.221 98.6222C34.3994 99.5326 39.3937 107.021 40.4344 110.628L49.5647 99.3957C51.2861 97.2779 54.5761 97.4679 56.0423 99.7697L60.9902 107.538C63.6063 111.645 63.6653 116.881 61.1424 121.046Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9994 15.7393C71.2128 15.7393 63.7194 24.447 65.1782 34.1242L69.5404 63.0619L106.604 52.3789L122.096 58.6625L125.771 34.1078C127.219 24.4356 119.728 15.7393 109.948 15.7393H80.9994Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.6,
    height: 203.2,
    fill: "white",
    transform: "translate(0.700195)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcContractServiceBodyMobile.5c63656f5bdcbeb1d31765b6f5d05bc9.svg";
export { ForwardRef as ReactComponent };